import React, { Suspense } from 'react';
import { LoadingFallback } from '@/main/LoadingFallback.atom';
import type { FormulaEditorProps } from '@/formula/formula.types';

const FormulaEditor = React.lazy(() => import('@/defaultExportShims/FormulaEditor'));

export const FormulaEditorAsync = (props: FormulaEditorProps) => {
  return (
    <Suspense fallback={<LoadingFallback size="sm" />}>
      <FormulaEditor {...props}></FormulaEditor>
    </Suspense>
  );
};
